module.exports = __webpack_public_path__ + "static/texas_womans-52e99bbbe117486e73b6681f724f489b.png";